import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { apiFetch } from '../utils/api';

const DriverDashboard = () => {
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = async () => {
        try { await apiFetch('/auth/logout', { method: 'POST' }); } catch(e) {}
        logout();
        navigate('/login');
    };

    return (
        <div className="admin-layout" style={{ minHeight: '100vh', padding: '0', display: 'block' }}>
            {/* Header */}
            <header className="glass-panel" style={{ padding: '24px 48px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderRadius: 0, borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
                <div className="sidebar-brand text-gradient" style={{ fontSize: '1.5rem', marginBottom: 0 }}>Driver Terminal</div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '24px' }}>
                    <span style={{ color: 'var(--text-muted)' }}>Shift: <strong style={{ color: 'var(--text-main)' }}>{user?.full_name}</strong></span>
                    <button className="btn-secondary" onClick={handleLogout}>Close Shift (Logout)</button>
                </div>
            </header>

            {/* Main Content */}
            <main style={{ padding: '48px', maxWidth: '1200px', margin: '0 auto' }}>
                <h2 style={{ color: 'var(--text-main)', marginBottom: '32px' }}>Assigned Dispatch</h2>
                
                <div className="glass-panel" style={{ padding: '48px', textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '16px' }}>
                    <div style={{ fontSize: '3rem', color: 'var(--text-muted)' }}>🚌</div>
                    <h3 style={{ fontSize: '1.5rem', color: 'var(--text-main)' }}>No Active Routing Assigned</h3>
                    <p style={{ color: 'var(--text-muted)', maxWidth: '400px' }}>
                        Your terminal is currently waiting for central administrative dispatch. Once a Route and Vehicle are assigned against your ID, they will populate here.
                    </p>
                </div>
            </main>
        </div>
    );
};

export default DriverDashboard;
